/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { NodeDependencies } from './dependenciesNode.generated.js';
import { createConditionalNode } from '../../factoriesNumber.js';
export var ConditionalNodeDependencies = {
  NodeDependencies,
  createConditionalNode
};